export default "__VITE_ASSET__9705a42a__"